import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl } from '@angular/forms';
import { ProblemaApi } from '../../core/models/requerimento';
import { mapearErrosApi } from '../../core/models/requerimento-mapper';

/** Página indisponível do fluxo do requerimento: a mesma tela do Instituto online, com a mensagem do requerimento. */
export const ROTA_PAGINA_INDISPONIVEL = '/requerimento-beneficio/pagina-indisponivel';

export type DestinoDoErro = (mensagens: string[]) => void;

export function rotaDoErroRequerimento(erro: unknown): string | null {
  if (!(erro instanceof HttpErrorResponse)) return ROTA_PAGINA_INDISPONIVEL;

  switch (erro.status) {
    case 400:
      return null;
    case 401:
      return '/token-invalido';
    case 404:
      return '/requerimento-beneficio';
    case 409:
      return '/requerimento-beneficio/detalhes';
    default:
      return ROTA_PAGINA_INDISPONIVEL;
  }
}

export function errosNosControles<C extends string>(
  controles: Record<C, AbstractControl>,
  campoDaApi: Record<string, C>,
): Record<string, DestinoDoErro> {
  return Object.fromEntries(
    Object.entries(campoDaApi).map(([chave, campo]) => [
      chave,
      (mensagens: string[]) => controles[campo].setErrors({ servidor: mensagens }),
    ]),
  );
}

export function distribuirErrosDaApi(
  erro: unknown,
  destinos: Record<string, DestinoDoErro>,
  mensagemPadrao: string,
): string[] {
  const problema = (erro instanceof HttpErrorResponse ? erro.error : null) ?? {};
  const erros = Object.entries(mapearErrosApi(problema as ProblemaApi));
  if (erros.length === 0) return [mensagemPadrao];

  const avisos: string[] = [];
  for (const [chave, mensagens] of erros) {
    const destino = destinos[chave];
    if (destino) destino(mensagens);
    else avisos.push(...mensagens);
  }
  return avisos;
}

export function mensagemDoServidor(controle: AbstractControl): string {
  const mensagens: string[] | null = controle.getError('servidor');
  return mensagens?.[0] ?? '';
}

/** A base unificada mudou depois da leitura do envio: o participante precisa rever o cadastro (409 do envio). */
export function precisaRevisarBase(erro: unknown): boolean {
  const problema = erro instanceof HttpErrorResponse ? (erro.error as ProblemaApi | null) : null;
  if (problema?.codigo === 'BaseUnificadaDivergente') return true;
  // Reserva: a API passou a mandar o codigo; esta checagem pelo texto sai na versão seguinte.
  return problema?.detail?.includes('mudaram na base unificada') ?? false;
}

/** Texto fixo da tela seguido do motivo devolvido pela API (ProblemDetails.detail), quando houver. */
export function mensagemComDetalhe(erro: unknown, mensagemFixa: string): string {
  const problema = erro instanceof HttpErrorResponse ? (erro.error as ProblemaApi | null) : null;
  return problema?.detail ? `${mensagemFixa} ${problema.detail}` : mensagemFixa;
}
